// extracted by mini-css-extract-plugin
export var cardContainer = "_np-0";
export var cardHeader = "_np-2";
export var collapsedState = "_np-3";
export var dragHandle = "_np-5";
export var dragHandleIcon = "_np-6";
export var dragging = "_np-1";
export var titleArea = "_np-4";